import PropTypes from 'prop-types';
import { memo } from 'react';
import TourTypeFilter from './TourTypeFilter';
import TourActivityFilter from './TourActivityFilter';
import TourDurationFilter from './TourDurationFilter';
import TourTimeWindowFilter from './TourTimeWindowFilter';
import TourPriceFilter from './TourPriceFilter';
import TourFeaturesFilter from './TourFeaturesFilter';
import TourDifficultyFilter from './TourDifficultyFilter';
import TourLanguageFilter from './TourLanguageFilter';

const TourFilters = ({ tripId }) => (
  <div className="flex flex-wrap gap-2 text-theme border-b-2 pb-2">
    <TourTypeFilter tripId={tripId} variant="outline" filterSpacingClass="py-2 px-3" />
    <TourActivityFilter tripId={tripId} variant="outline" filterSpacingClass="py-2 px-3" />
    <TourDurationFilter tripId={tripId} variant="outline" filterSpacingClass="py-2 px-3" />
    <TourTimeWindowFilter tripId={tripId} variant="outline" filterSpacingClass="py-2 px-3" />
    <TourPriceFilter tripId={tripId} variant="outline" filterSpacingClass="py-2 px-3" />
    <TourFeaturesFilter tripId={tripId} variant="outline" filterSpacingClass="py-2 px-3" />
    <TourDifficultyFilter tripId={tripId} variant="outline" filterSpacingClass="py-2 px-3" />
    <TourLanguageFilter tripId={tripId} variant="outline" filterSpacingClass="py-2 px-3" />
  </div>
);

TourFilters.propTypes = {
  tripId: PropTypes.string,
};

TourFilters.defaultProps = {
  tripId: undefined,
};

export default memo(TourFilters);
